<template>
  <div class="login">
    <BackHome title="志愿者登录" />
    <div class="content">
      <a-input
        v-model="name"
        placeholder="请输入您的证件号"
        class="input-common"
        size="large"
      >
        <img slot="prefix" :src="image1" alt="" class="image" />
      </a-input>
      <a-input-password
        placeholder="请输入密码"
        v-model="password"
        class="input-common"
        size="large"
      >
        <img slot="prefix" :src="image2" alt="" class="image" />
      </a-input-password>

      <div class="button submit" @click="login">登录</div>
      <div class="button register" @click="register">我要注册</div>
      <div class="bottom">
        <a-checkbox
          @change="onChange"
          :checked="checked"
          class="left"
          >记住用户名</a-checkbox
        >
        <div class="right" @click="gotoForgot">忘记密码</div>
      </div>
    </div>
  </div>
</template>

<script>
import BackHome from "@/components/common/BackHome.vue";

export default {
  components: {
    BackHome,
  },
  data() {
    return {
      image1: require("@/assets/img/common/login_card@2x.png"),
      image2: require("@/assets/img/common/login_password@2x.png"),
      checked: false,
      name: "",
      password: "",
      loading: false,
    };
  },
  created () {
    const userName = localStorage.getItem('jz_user');
		if (userName) {
      (userName);
			this.name = userName;
			this.checked = true;
		}
    // this.$EventBus.$emit('showMenu', false);
	},
  methods: {
    login() {
      if (!this.name) {
        this.$message.error("请输入您的证件号");
        return;
      }
      if (!this.password) {
        this.$message.error("请输入密码");
        return;
      }
      if (this.loading) return;
      this.$api.vmsapi.login({username: this.name, password: this.password}).then(res => {
        localStorage.setItem('jz_vol_token', res.token);
        this.userIdRequest(res.token);
      }).catch(() => {
        this.loading = false;
      });
    },
    userIdRequest(token) {
      this.$api.vmsapi.getUserId(token).then(res => {
        localStorage.setItem('jz_vol_zyzid', res.userId);
        if (this.checked) {
          localStorage.setItem('jz_user', this.name)
        } else {
          localStorage.removeItem('jz_user');
        }
        this.$router.replace({name: 'home'});
      }).finally(() => {
        this.loading = false;
      });
    },
    register() {
      this.$router.replace({ name: "register" });
    },
    onChange() {
      this.checked = !this.checked;
    },
    gotoForgot() {},
  },
};
</script>

<style lang="scss" scoped>

.login {
  width: 770px;
  margin: 0 auto;
  margin-bottom: 100px;
  
  .content {
    background-color: #ffffff;
    padding: 50px 180px 80px;

    .image {
      width: 20px;
      height: 20px;
    }
    .input-common {
      margin-bottom: 20px;
      font-size: 14px;
      font-family: Helvetica;
      height: 36px;
    }

    .button {
      height: 36px;
      border-radius: 2px;
      margin-bottom: 20px;
      cursor: pointer;

      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: Helvetica;
    }
    .submit {
      background: #cd3232;
      color: #ffffff;
    }
    .register {
      background: #ffffff;
      color: #cd3232;
      border: 1px solid #cd3232;
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        font-size: 14px;
        font-family: Helvetica;
        color: #727384;
      }
      .right {
        font-size: 14px;
        font-family: Helvetica;
        color: #cd3232;
        cursor: pointer;
      }
    }
  }
}
</style>